import axios from "axios";
import Errores from "@/utils/Errores";
//import Datos from "@/assets/js/resultado";

let validarResultado = async (authentication, componente) => {
  let url = API.RESULTADOS;
  let resultado = await axios
    .get(url + "v1/private/resultados/validar", {
      headers: {
        Authorization: "Bearer " + authentication
      }
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      Errores.switchErrors(error, componente, [
        {
          codigo: 404,
          mensaje: ""
        },
        {
          codigo: 409,
          mensaje: ""
        }
      ]);
      return null;
    });
  return resultado;
};

//let validarComprobantePrueba = async () => {
//  return Datos.datos;
//}

export default {
  validarResultado
  //  validarComprobantePrueba
};



// WEBPACK FOOTER //
// ./src/service/ApiResultado.js